function productSlider() {

    var slider = $('._js-product-slider');

    if ( slider.length ) {
        slider.each(function(){
            var _this = $(this),
                _controls = $(this).parents('.custom-controls');

            _this.slick({
                rows: 0,
                slide: '.product-slider__element',
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev"><svg class="i _shevron-left"><use xlink:href="#shevron-left"/></svg></button>',
                nextArrow: '<button type="button" class="slick-next"><svg class="i _shevron-right"><use xlink:href="#shevron-right"/></svg></button>',
                dots: true,
                infinite: false,
                appendArrows: $('.custom-controls__controls', _controls),
                appendDots: $('.custom-controls__controls', _controls),
                responsive: [
                    {
                        breakpoint: 1670,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 599,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ],
                customPaging: function (slider,i){
                    return '<button class="slick-dots__button" type="button"></button>';
                }
            });
        });

    }

}